import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { useConfirmRefund } from "../../../apis";
import { ConfirmRefundModalProps } from "./ConfirmRefundModal.types";

import styles from "./ConfirmRefundModal.module.scss";

const ConfirmRefundModal = ({
  refundId,
  isOpen,
  onClose,
  onSuccess
}: ConfirmRefundModalProps) => {
  const { t } = useTranslation();

  const { mutate: confirmRefund, isLoading } = useConfirmRefund({
    onSuccess: () => {
      toast.success(t("Refund confirmed successfully"));
      onSuccess?.();
      onClose?.();
    }
  });

  return (
    <Modal
      isOpen={isOpen}
      title={t("Confirm Refund")}
      okText="Confirm"
      isLoading={isLoading}
      onOk={() => confirmRefund(refundId)}
      contentClassName={styles.payEarningsModal}
      onClose={onClose}
    >
      <p className={styles.payEarningsModal_text}>
        {t("Are you sure you want to confirm the refund?")}
      </p>
    </Modal>
  );
};

export default ConfirmRefundModal;
